import { useRef } from 'react';
import SelectableListItem from '@/components/common/selectable-list/selectable-list-item';
import useConversationStore from '@/hooks/conversations/use-conversation-store';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import cn from '@/utils/merge-class-names';
import MessageContent from './message-content/message-content';
import useMessageInfo from './use-message-info';

interface Props {
  className?: string;
  isHighlighted?: boolean;
  showHeader?: boolean;
  type?: 'quote' | 'clamped';
  message: ConversationMessageTypeUnion;
  onResize?: () => void;
}

export default function MessageListItem({
  message,
  type,
  showHeader = true,
  isHighlighted,
  className,
  onResize,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const { isMine, isNotification } = useMessageInfo(message);
  const { selectedMessages, toggleSelectedMessage, multiselectAction } = useConversationStore();

  const isSelected = selectedMessages.some((m) => m.ID === message.ID);

  return (
    <div
      ref={ref}
      key={`message-${message.ID}`}
      id={`message-${message.ID}`}
      data-side={isMine ? 'sender' : 'receiver'}
      className={cn(
        'flex max-w-full select-none desktop:select-text items-center transition group px-5 py-3',
        {
          'bg-metal-100': isHighlighted,
        },
        className,
      )}>
      <SelectableListItem
        isSelected={isSelected}
        isSelectable={multiselectAction !== null && !isNotification}
        onSelected={() => toggleSelectedMessage(message)}>
        <MessageContent
          showHeader={showHeader}
          message={message}
          type={type}
          onResize={onResize}
        />
      </SelectableListItem>
    </div>
  );
}
